import * as Yup from 'yup'

/**
 * Fonte única da política de senha forte do frontend (epic SBIS NGS1.02).
 *
 * Mantenha estas mensagens e regras idênticas em todos os formulários que CRIAM
 * ou TROCAM senha (passwordSchema, SignInMethod, profileSchema).
 * Não altere os limites (8/32) nem as classes de caractere ([@$!%*#?&]) sem
 * revisar a política — esta é apenas a unificação da regra já existente.
 */
export const MENSAGENS_SENHA = {
  min: 'Mínimo de 8 caracteres',
  max: 'Máximo de 32 caracteres',
  minuscula: 'Inserir pelo menos uma letra minúscula',
  maiuscula: 'Inserir pelo menos uma letra maiúscula',
  especial: 'Inserir pelo menos um caractere especial',
  numero: 'Inserir pelo menos um número',
} as const

/**
 * Retorna um `Yup.string()` com a cadeia completa da senha forte (sem
 * `.required()`/`.oneOf()`, que ficam a cargo de cada formulário). Como os
 * schemas do Yup são imutáveis, cada chamada devolve uma instância nova.
 */
export const senhaForteSchema = () =>
  Yup.string()
    .min(8, MENSAGENS_SENHA.min)
    .max(32, MENSAGENS_SENHA.max)
    .matches(/[a-z]+/, MENSAGENS_SENHA.minuscula)
    .matches(/[A-Z]+/, MENSAGENS_SENHA.maiuscula)
    .matches(/[@$!%*#?&]+/, MENSAGENS_SENHA.especial)
    .matches(/\d+/, MENSAGENS_SENHA.numero)
